import React, { useState } from "react";
import { Box, Button, Switch, TextField, Select, MenuItem, IconButton } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import CreateChoice from "./createChoise"; // React版CreateChoiceコンポーネントをインポート

const CreateQuestion = ({ onCreateQuestion }) => {
  const forms = [
    { label: "記述（一行）", value: "textfield" },
    { label: "記述（複数行）", value: "textarea" },
    { label: "ラジオボタン", value: "radiobutton" },
    { label: "チェックボックス", value: "checkbox" },
    { label: "プルダウン", value: "pulldown" },
  ];

  const requireChoice = ["radiobutton", "checkbox", "pulldown"];

  const [formType, setFormType] = useState("");
  const [showChoices, setShowChoices] = useState(false);
  const [choices, setChoices] = useState([]);
  const [formLabel, setFormLabel] = useState("");
  const [questionRequire, setQuestionRequire] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [showAddBtn, setShowAddBtn] = useState(true);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formLabel) {
      newErrors.formLabel = "必須事項です";
    }
    if (formLabel.length > 300) {
      newErrors.formLabel = "300字以内で入力してください";
    }
    if (!formType) {
      newErrors.formType = "入力方法を選択してください";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleAddChoice = (choice) => {
    setChoices((prevChoices) => [...prevChoices, choice]);
  };

  const handleRemoveChoice = (index) => {
    setChoices((prevChoices) => prevChoices.filter((_, i) => i !== index));
  };

  const handleAddQuestion = () => {
    if (!validate()) {
      return;
    }

    const question = {
      formLabel,
      formType,
      questionRequire,
      choices,
    };

    setDisabled(true);
    setShowAddBtn(false);

    if (onCreateQuestion) {
      onCreateQuestion(question);
    }
  };

  const handleFormTypeChange = (event) => {
    const selectedType = event.target.value;
    setFormType(selectedType);
    setShowChoices(requireChoice.includes(selectedType));
  };

  return (
    <Box component="form">
      <Box display="flex" mb={2}>
        <TextField
          label="質問"
          value={formLabel}
          onChange={(e) => setFormLabel(e.target.value)}
          disabled={disabled}
          error={!!errors.formLabel}
          helperText={errors.formLabel}
          inputProps={{ maxLength: 300 }}
          fullWidth
        />
      </Box>
      <Box display="flex" alignItems="center" mb={2}>
        <Select
          value={formType}
          onChange={handleFormTypeChange}
          disabled={disabled}
          fullWidth
          displayEmpty
        >
          <MenuItem value="" disabled>
            入力方法を選択
          </MenuItem>
          {forms.map((form) => (
            <MenuItem key={form.value} value={form.value}>
              {form.label}
            </MenuItem>
          ))}
        </Select>
        <Switch
          checked={questionRequire}
          onChange={(e) => setQuestionRequire(e.target.checked)}
          disabled={disabled}
        />
        <span>必須</span>
      </Box>
      {showChoices && (
        <Box>
          {choices.map((choice, index) => (
            <Box key={index} display="flex" alignItems="center" mb={1}>
              <CreateChoice onCreateChoice={handleAddChoice} disableParent={disabled} />
              <IconButton
                color="error"
                onClick={() => handleRemoveChoice(index)}
                disabled={disabled}
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ))}
          <Button
            startIcon={<AddIcon />}
            variant="outlined"
            color="primary"
            onClick={() => setChoices((prev) => [...prev, ""])}
            disabled={disabled}
          >
            選択肢を追加
          </Button>
        </Box>
      )}
      {showAddBtn && (
        <Box mt={2}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleAddQuestion}
            disabled={disabled}
          >
            質問を追加
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default CreateQuestion;